import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import Awards from "./Github"; // ← دلوقتي ده هو مكون الجوائز
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard"; // ← الشهادات
import Toolstack from "./Toolstack"; // ← الخبرة

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        {/* Experience */}
        <section style={{ marginBottom: "80px", marginTop: "40px" }}>
          <h1 className="project-heading" style={headingStyle}>
            <strong className="purple">My</strong> Experience
          </h1>
          <Toolstack />
        </section>

        {/* Certifications */}
        <section style={{ marginBottom: "80px" }}>
          <h1 className="project-heading" style={headingStyle}>
            My <strong className="purple">Certifications</strong>
          </h1>
          <Aboutcard />
        </section>

        {/* Skillset */}
        <section style={{ marginBottom: "80px" }}>
          <h1 className="project-heading" style={headingStyle}>
            Professional <strong className="purple">Skillset</strong>
          </h1>
          <Techstack />
        </section>

        {/* Awards */}
        <section style={{ marginBottom: "60px" }}>
          <h1 className="project-heading" style={headingStyle}>
            <strong className="purple">Awards</strong>
          </h1>
          <Awards />
        </section>
      </Container>
    </Container>
  );
}

const headingStyle = {
  fontSize: "2.2em",
  marginBottom: "30px",
  fontWeight: "700",
  textAlign: "center",
  lineHeight: "1.4",
};

export default About;
